import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined';
import LocalCafeOutlinedIcon from '@mui/icons-material/LocalCafeOutlined';
import RestaurantOutlinedIcon from '@mui/icons-material/RestaurantOutlined';
import LocalBarOutlinedIcon from '@mui/icons-material/LocalBarOutlined';
import HotelOutlinedIcon from '@mui/icons-material/HotelOutlined';
import DirectionsBusOutlinedIcon from '@mui/icons-material/DirectionsBusOutlined';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import DirectionsRunOutlinedIcon from '@mui/icons-material/DirectionsRunOutlined';
import ParkOutlinedIcon from '@mui/icons-material/ParkOutlined';
import MuseumOutlinedIcon from '@mui/icons-material/MuseumOutlined';
import TheaterComedyOutlinedIcon from '@mui/icons-material/TheaterComedyOutlined';
import MilitaryTechOutlinedIcon from '@mui/icons-material/MilitaryTechOutlined';

export const STANDARD_MAP_PIN_KEYS = [
	'meeting_point',
	'cafes',
	'restaurants',
	'bars',
	'accommodation',
	'transportation',
	'shopping',
	'activity',
	'nature',
	'sightseeing',
	'culture',
	'events',
];

export const STANDARD_MAP_PIN_ICON_COMPONENTS = {
	'meeting_point': RoomOutlinedIcon,
	'cafes': LocalCafeOutlinedIcon,
	'restaurants': RestaurantOutlinedIcon,
	'bars': LocalBarOutlinedIcon,
	'accommodation': HotelOutlinedIcon,
	'transportation': DirectionsBusOutlinedIcon,
	'shopping': ShoppingBagOutlinedIcon,
	'activity': DirectionsRunOutlinedIcon,
	'nature': ParkOutlinedIcon,
	'sightseeing': MuseumOutlinedIcon,
	'culture': TheaterComedyOutlinedIcon,
	'events': MilitaryTechOutlinedIcon,
};


